var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchliesskreuz01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Schliesskreuz-01__Icn/40px/Schliesskreuz-01",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4852814,15 L24.8994949,16.4142136 L21.364,19.95 L24.8994949,23.4852814 L23.4852814,24.8994949 L19.95,21.364 L16.4142136,24.8994949 L15,23.4852814 L18.536,19.95 L15,16.4142136 L16.4142136,15 L19.95,18.536 L23.4852814,15 Z",
    id: ".._.._src_svg_Icn_40px_Schliesskreuz-01__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchliesskreuz01);
export default __webpack_public_path__ + "static/media/Schliesskreuz-01.238317afa4fe79f71ebb642a4462fb59.svg";
export { ForwardRef as ReactComponent };